import { GetTeamSsoAppClientDataResponse } from '@cbinsights/authservice/authservice';
import { UseQueryResult, useQuery } from 'react-query';
import { GetTeamSsoAppClientData } from '.';
import { getTeamSsoAppClientData } from '../api/GetTeamSsoAppClientData';

type Params = Parameters<typeof getTeamSsoAppClientData>[0];
type Return = GetTeamSsoAppClientDataResponse;

export const useGetTeamSsoAppClientData = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetTeamSsoAppClientData, Params]>(
    ['GetTeamSsoAppClientData', params],
    () => getTeamSsoAppClientData(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
